import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompElectricMoto({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [infoElectricComponent, setInfoCompElectric] = useState({
    Engine_start: 0,
    Tachometer: 0,
    ligth_commands: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'EC', data: infoElectricComponent });
  });

  const handleForm = ({ target }) => {
    const tmpElectricComp = { ...infoElectricComponent, [target.name]: target.value }
    setInfoCompElectric(tmpElectricComp);
    autosave.schedule();
    //generalUpdate('infoElectricComponent', tmpElectricComp)
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get(`/peritaje/infostate/C`, {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e) => e.name.toLowerCase() === 'bueno')
      setInfoCompElectric({
        Engine_start: currentDefaultState.id,
        ligth_commands: currentDefaultState.id,
        Tachometer: currentDefaultState.id,
      });
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { type: 'EC', data: infoElectricComponent };
    const respo = await post('/peritaje/modifyinspection/components/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };
  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'EC' };
      const tmpElectric = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpElectric[element.name] = element.id_state;
        }
        if (detail.length > 0) setInfoCompElectric(tmpElectric);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner /> : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">EQUIPAMIENTO ELECTRICO</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Engine_start">Arranque de motor</Form.Label>
          <Form.Select
            name="Engine_start"
            value={infoElectricComponent.Engine_start}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="ligth_commands">Comando de Luces</Form.Label>
          <Form.Select
            name="ligth_commands"
            value={infoElectricComponent.ligth_commands}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="Tachometer">Tacometro</Form.Label>
          <Form.Select
            name="Tachometer"
            value={infoElectricComponent.Tachometer}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompElectricMoto;
